import { type CSSProperties } from 'react';

const styles: Record<string, CSSProperties> = {
  wrapper: {
    display: 'flex',
    position: 'relative',
    textAlign: 'initial',
  },
  fullWidth: {
    width: '100%',
  },
  hide: {
    display: 'none',
  },
};

export default styles;
